<template>

  <div>

    <template v-if="context.parent && context.parent.tag==='subForm'">
      <dept-select v-if="type==='fill'" ref="deptSelect" v-model="data[element.id]"
                   :multiple="element.attrs.multiple" :disabled="context.authentication.isDisabled(element,data) || !context.authentication.isWrite(element)"></dept-select>
      <div v-else-if="type==='detail'">
        <div v-if="data[element.id]" style="display: flex;align-items: center;">
          <el-icon>
            <Stamp></Stamp>
          </el-icon>
          <span style="margin-left: 4px">{{ depts.map(mapper => mapper.name).join(', ') }}</span>
        </div>
        <span v-else></span>
      </div>
    </template>

    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
      <span
          :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
       <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <dept-select v-if="type==='fill'" ref="deptSelect" v-model="data[element.id]"
                   :multiple="element.attrs.multiple"></dept-select>
      <div v-else-if="type==='detail'" class="design-detail">
        <div v-if="data[element.id]" style="display: flex;align-items: center;">
          <el-icon>
            <Stamp></Stamp>
          </el-icon>
          <span style="margin-left: 4px">{{ depts.map(mapper => mapper.name).join(', ') }}</span>
        </div>
        <span v-else>&nbsp;</span>
      </div>
    </el-form-item>

  </div>


</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useDeptStore} from "@/stores/dept";
import deptSelect from "@/components/common/deptSelect.vue";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";

export default {
  components: {FormElementTooltip, deptSelect},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: {},
      type: '',
      depts: [],
    }
  },
  computed: {
    ...mapStores(useFlowStore, useDeptStore)
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);

    if (this.type === 'detail') {
      this.findDeptByIds();
    }
  },
  mounted() {
    this.initWatch();
  },
  methods: {
    findDeptByIds() {
      let value = this.data[this.element.id];
      if (value) {
        if (typeof value === 'string') {
          this.deptStore.findById(value).then(res => {
            this.depts.push(res.data);
          })
        } else {
          value.forEach(deptId => {
            this.deptStore.findById(deptId).then(res => {
              this.depts.push(res.data);
            })
          })
        }
      }
    },
    initWatch() {

      if (this.type === 'fill' && !this.element.attrs.multiple) {

        this.$watch(`data.${this.element.id}`, this.handleChange, {
          deep: true,
          immediate: false
        });

        if (this.context.rawData) {
          this.$watch(`context.rawData.${this.element.id}`, this.handleChange, {
            deep: true,
            immediate: false
          });
        }


      }
    },
    handleChange(id) {

      const getVal = (fillRule, value) => {

        if (fillRule.from === 'deptManager') {
          return value.charges[0];
        } else if (fillRule.from === 'name') {
          return value.real_name;
        }

        return null
      }


      if(id){
        this.deptStore.findById(id).then(res => {
          let val = res.data;
          this.element.attrs.fill?.forEach(item => {
            if (Object.keys(this.data).includes(item.to)) {
              try {
                this.data[item.to] = getVal(item, val)
              } catch (e) {

              }

            }
            if (this.context.rawData && Object.keys(this.context.rawData).includes(item.to)) {
              try {
                this.data[item.to] = getVal(item, val)
              } catch (e) {

              }
            }
          })

        })
      }


    }
  }
}

</script>

<style scoped lang="scss">

</style>